import { ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild, ViewEncapsulation, OnDestroy, TemplateRef } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { parsePhoneNumberFromString, isValidNumber, parsePhoneNumber, CountryCode } from 'libphonenumber-js';
import { ModalComponent, ModalModel } from '../modal/modal.component';
import { AbstractControl, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { EditContactService } from 'src/app/pages/contact-profile/edit-contact/services/edit-contact.service';
import { Contacts } from 'src/app/pages/contact-profile/edit-contact/modal/add-contact-model';
import { AddCategoryComponent } from 'src/app/pages/items/add-category/add-category.component';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';


@Component({
    selector: 'app-phone-number',
    templateUrl: './phone-number.component.html',
    styleUrls: ['./phone-number.component.scss'],
    encapsulation: ViewEncapsulation.Emulated,
    standalone: false
})
export class PhoneNumberComponent implements OnInit, OnChanges, OnDestroy {
  selectedCountry: any;
  addContactForm: FormGroup;
  formOfContactForm1: FormGroup;
  formOfContactFormSubmit = false;
  openBulkAction:boolean = false;
  // color:any;
  currentIndex:any
  contactModel = new Contacts;
  private _unsubscribeAll: Subject<any> = new Subject();
  isValidationTriggered = false;
  duplicateNameError = false; // shows inline error when an existing phone-type name is re-added
  @Input() isIconShow: boolean;
  @Input() addedNew: boolean=false;
  @Input() table: boolean;
  @Input() titleRequired: boolean=false;
  @Input() businessContact: any
  @Input() countryListArr: any;
  @Input() defaultMerchantCountry: any
  @Input() paddingLeft: boolean;
  @Input() typeOfCustom: any;
  @Input() moduleName: boolean;
  @Input() labelName: any;
  @Input() flag: boolean;
  @Input() notFromEQuote: boolean=true;
  @Input() notFromEQuoteOrg: boolean=false;
  @Input() phoneRequired: boolean=false;
  @Input() showPhoneError: boolean=false;
  @Input() showPhoneNameError : boolean=false
  @Input() fields: any;
  @Input() isEquote: any;
  @Output() removeContact: EventEmitter<any> = new EventEmitter<any>();
  @Output() isLabel: EventEmitter<any> = new EventEmitter<any>();
  @Output() sendSelectedContacts: EventEmitter<any> = new EventEmitter<any>();
  @Output() isValidNumber: EventEmitter<any> = new EventEmitter<any>();
  /**
   * Fires on every USER edit of the phone list: type, number, country code, a row
   * added or removed. Never fires while the stored numbers are loaded or formatted,
   * so a parent can use it to enable "Save" (workspace profile).
   */
  @Output() contactsEdited: EventEmitter<void> = new EventEmitter<void>();
  @ViewChild('content', { static: false }) modal;
  @ViewChild('clientTypesForm') clientTypesForm;
  @ViewChild('roleForm') roleForm;
  @ViewChild('customFieldForm') customFieldForm;
  @ViewChild('socialLinkForm') socialLinkForm;
  @ViewChild('closesocialbutton') closesocialbutton;
  @ViewChild('addFormClientTypeButton') addFormClientTypeButton;
  @ViewChild('addRoleContactButton') addRoleContactButton;
  @ViewChild('fnameRef') fnameRef: ElementRef;
  @ViewChild('phoneNameDialog') phoneNameDialog: TemplateRef<any>;
   selectedPhoneNumber: any;
  phoneDataArr: any;
  formContactListArr: any;
  formContactListArrData: any;
  private phoneNameDialogRef: MatDialogRef<any> | null = null;
  constructor(
    private translateService: TranslateService,
    public dialog: MatDialog,
    private fb: FormBuilder,
    private formBuilder: FormBuilder,
    private editContactService: EditContactService,
    private snackBar: MatSnackBar,
    private cdr: ChangeDetectorRef,


  ) {
    // this.isIconShow = true;
  }

  async ngOnInit() {
    if(!this.notFromEQuote){
      this.businessContact.forEach(contact => {
        if(contact.mobile_number){
          this.showPhoneError = false;
          this.showPhoneNameError= false
          this.removeErrorMsg();
        }
        if (this.fields?.type?.length ==1) {
          contact.name = this.fields.type[0];
        }
      });
    }
  
        
    this.contactBasicInfoFormVal()    
    setTimeout(async () => {
      if(this.notFromEQuote){
        await this.getAllListing()
      }      
    
      if(this.defaultMerchantCountry){
        
        console.log(this.defaultMerchantCountry,'this.defaultMerchantCountry');
        console.log(this.businessContact,'this.businessContactthis.businessContact');
        
        this.selectedCountry = this.defaultMerchantCountry?.country_code || 'US';
        this.businessContact.forEach((value,index)=>{
          if(!value.countryId){
            this.businessContact[index].countryId = this.defaultMerchantCountry?.id
            this.businessContact[index].country_code = this.defaultMerchantCountry?.country_code;
          }
          
        })
      }else{
        this.cdr.detectChanges()
      
      }
    }, 500);
   
    
    
  }
  ngOnChanges(changes): void {
    if(changes?.addedNew?.currentValue==true){
      this.getAllListing();
    }
    this.businessContact.forEach((value, index) => {      
      if (value.mobile_number) {
        let phoneNumber: any = parsePhoneNumberFromString(value.mobile_number, value?.country?.country_code || this.selectedCountry);
        if (phoneNumber) {
          this.selectedPhoneNumber = phoneNumber.number;
          this.businessContact[index].mobile_number = phoneNumber.formatNational();
          // this.businessContact[index].mobile_number = value?.country?.id;
        }
      }
    });
  if (
  (changes?.showPhoneError?.currentValue === true) ||
  (changes?.showPhoneNameError?.currentValue === true)
) {
  this.isValidationTriggered = true;   // mark validation mode
  this.removeErrorMsg();
}
  }

  addFormOfContact(event: any) {
    if (event == 'addFormOfContact') {
      this.openPhoneNameModal();
    }
  }

  triggerAddFormOfContact(event: MouseEvent): void {
    event.stopPropagation(); // Prevent closing the dropdown or selecting value
    this.duplicateNameError = false; // clear any stale error from a previous open
    this.formOfContactFormSubmit = false;
    this.openPhoneNameModal();
  }

  /**
   * Use MatDialog (not Bootstrap). Nested Bootstrap modals paint a fullscreen white
   * layer behind the organization MatDialog under CDK 21's popover top layer.
   */
  private openPhoneNameModal(): void {
    if (!this.phoneNameDialog) {
      return;
    }
    this.phoneNameDialogRef?.close();
    this.phoneNameDialogRef = this.dialog.open(this.phoneNameDialog, {
      width: '600px',
      autoFocus: 'input',
      restoreFocus: true,
      panelClass: 'phone-name-dialog-panel',
    });
  }

  closePhoneNameModal(): void {
    this.phoneNameDialogRef?.close();
    this.phoneNameDialogRef = null;
  }

  contactBasicInfoFormVal() {
      this.addContactForm = this.formBuilder.group(
        {
          formContactId: [''],
        },
      );
      this.formOfContactForm1 = this.formBuilder.group(
        {
          name: ['', Validators.required],
        
        },
      );
  }
  get formOfContact(): { [key: string]: AbstractControl } {
    return this.formOfContactForm1?.controls;
  }

  openBulkActionPopup(event,i){
  this.currentIndex = i
    event.stopPropagation();
    this.formContactListArr.map((x,index)=>{
      if(i === index){
        this.openBulkAction = !this.openBulkAction
      } 
    })
    
  }

  addFormOfContactList1() {
    this.formOfContactFormSubmit = true;
    if (this.formOfContactForm1.invalid) {
      return
    }
    // Block duplicate phone-type names (case-insensitive). Show an inline error
    // and keep the modal open instead of silently adding/closing.
    const enteredName = this.formOfContactForm1.value?.name?.toString().trim().toLowerCase();
    const isDuplicate = (this.formContactListArr || []).some(
      item => item?.name?.toString().trim().toLowerCase() === enteredName
    );
    if (isDuplicate) {
      this.duplicateNameError = true;
      return;
    }
    this.duplicateNameError = false;
    const addformOfContactTypesSubs = this.editContactService.addformOfContactTypes({...this.formOfContactForm1.value,label:this.labelName,module_name:this.moduleName}).pipe(takeUntil(this._unsubscribeAll)).subscribe((res) => {
      this.closePhoneNameModal();
      this.formOfContactForm1.reset();
      this.formOfContactFormSubmit = false;
      this.duplicateNameError = false;
      this.getAllListing();
    })
    // this.subscriptions.push(addformOfContactTypesSubs);
  }

  // async removeItem(i, type) {
  //   const dialogData = new ModalModel(this.translateService.instant('PROFILE.CONFIRMDELETE'));
  //   const dialogRef = this.dialog.open(ModalComponent, {
  //     width: "450px",
  //     data: dialogData
  //   });
  //   dialogRef.afterClosed().subscribe(async (dialogResult) => {
  //     if (dialogResult) {

  //       if (type == 'removeSocialInfo') {
  //         this.contactSocialInfoArr.splice(i, 1);
  //         this.socialInfo.removeAt(i);
  //       }

  //       if (type == 'removeSocialLink') {
  //         this.addsocialLinkArr.splice(i, 1);
  //       }

  //       if (type == 'removeCustomField') {
  //         this.deleteCustomField(i);
  //       }
  //       if (type == 'deleteFormClientType') {
  //         this.deleteFormClientType(i)
  //       }
  //       if (type == 'deleteformContact') {
  //         this.deleteformContact(i)
  //       }
  //       if (type == 'deleteRoleForm') {
  //         this.deleteRoleForm(i)
  //       }
  //       if (type == 'Delete_Address') {
  //         this.customerAddressArr.splice(i, 1);
  //       }
  //     }
  //   });
  // }


  getTranslatedText(key: string): string {
    const translation = this.translateService.instant(key);
    return translation !== key ? translation : '';
  }


  /**
   * Change Phone Code on Select item from dropdown.
   */

  changephonenumberselect(event,type:any='') {    
    // this.businessContact[event.index].mobile_number = ""; 
    if (event.index >= 0) {
      if (event.type == 'countryId' || event.type == 'countryIdOrg') {
        const country = this.countryListArr.find(country => country.id == event.value);
        if (country) {
          const previousCountryId = this.businessContact[event.index].countryId;
          this.selectedCountry = country.country_code;
          this.businessContact[event.index].country_code = this.selectedCountry;
          this.businessContact[event.index].countryId = Number(event.value);

          // Trigger formatting when country changes
          if (this.businessContact[event.index].mobile_number) {
            this.formatPhoneNumber(this.businessContact[event.index].mobile_number, event.index);
          }
          if (Number(previousCountryId) !== Number(event.value)) {
            this.contactsEdited.emit();
          }
        }
      }
    }
  }
  // add phone number row with blank value
  // addPhoneRow() {
  //   console.log(this.fields,'kkkk')
  //   this.businessContact.push({ value: "" });
  //   this.sendSelectedContacts.emit(this.businessContact)
  // }

 addPhoneRow() {
  // Get the field_length from the received data
    // let fieldLength
    // if(this.fields?.field_length){
    //    fieldLength = this.fields.field_length;

    // }
  
    // Check the current number of rows in businessContact
    // if(fieldLength){
    //   if (this.businessContact.length < fieldLength) {
    //     this.businessContact.push({ value: "" });
    //     this.sendSelectedContacts.emit(this.businessContact);
    //   } else {
    //     this.snackBar.open(`You cannot add more then ${fieldLength} phone numbers` , 'Close', {
    //       duration: 2000,
    //       panelClass: ['custom-snackbar']
    //     });
    //   }
    // }else{
  if(this.businessContact?.length){
    const length = 1;
        for (let i = 0; i < length; i++) {
      const contact = this.businessContact[i];

      this.businessContact.push({
        countryId: contact?.countryId || '',
        mobile_number: '',
        name: '',
        order: i,
        phoneError: false,      // track mobile number error per row
        phoneNameError: false   // track name/type error per row
      });
    }
  } else {
    this.businessContact.push({ value: "" });}

  this.sendSelectedContacts.emit(this.businessContact);
  this.contactsEdited.emit();

  // Only validate new row if Next was already clicked
  if(this.isValidationTriggered){
    this.removeErrorMsg();
  }
}
 


  /**
   * Normalises the raw type list for the dropdown so only clean, individual phone
   * types (e.g. Home, Office, Mobile) are shown.
   *
   * Some records come back as malformed, positionally-joined "combo" values —
   * e.g. "Home;;Mobile", ";Office;", "Home;Office;Mobile" (legacy/corrupt data) —
   * which leaked into the UI as garbage options. We split each name back on ";",
   * drop the empty segments, and surface each distinct type once (case-insensitive,
   * trimmed). For each type we prefer a record whose own name already equals that
   * type exactly, so its metadata (id/color) — and thus edit/delete — targets the
   * real row. Non-array input returns an empty array; empty names are dropped
   * (the template already renders its own blank placeholder option).
   */
  private normalizeTypeOptions(list: any): any[] {
    if (!Array.isArray(list)) return [];
    const seen = new Set<string>();
    const result: any[] = [];
    for (const item of list) {
      const raw = item?.name?.toString() ?? '';
      const names = raw
        .split(';')
        .map((s: string) => s.trim())
        .filter(Boolean);
      for (const name of names) {
        const key = name.toLowerCase();
        if (seen.has(key)) continue;
        seen.add(key);
        const exact = list.find(
          (x: any) => x?.name?.toString().trim().toLowerCase() === key
        );
        result.push({ ...(exact || item), name });
      }
    }
    return result;
  }

  async getAllListing() {
    try {
      let merchantId = localStorage.getItem('merchant_id');
      console.log("merchant id : ",merchantId);
      const formContactListSubs = await this.editContactService.formContactList({label:this.labelName}).toPromise()
      console.log("formContactListSubs",formContactListSubs);
      // Normalise to clean, individual type options: split any malformed
      // ";"-joined combo names (e.g. "Home;;Mobile", ";Office;") back into single
      // types and de-duplicate by name. The option value is bound to `name`, so
      // same-named records are interchangeable.
      const normalizedList = this.normalizeTypeOptions(formContactListSubs.data);
      this.formContactListArr = normalizedList;
      this.formContactListArrData = normalizedList
    } catch (error) {
      console.log("Listing error",error);
    }
  }
changephonenumberinput(event, i, type) {

  const contact = this.businessContact[i];
  const previousNumber = contact.mobile_number;

  if (type === 'mobile_number') {
    contact.mobile_number = event;
    this.formatPhoneNumber(event, i);
    contact.order = i;

    contact.phoneError = !event; // only this row
  }

  if (type === 'name') {
    contact.name = event;
    contact.order = i;

    contact.phoneNameError = !event; // only this row

    this.sendSelectedContacts.emit(this.businessContact);
  }

  // Only a real change counts.
  // - Number: the input is one-way bound, so contact.mobile_number still holds the old
  //   value here and the same value arriving again is not an edit.
  // - Type: the select is two-way bound ([(ngModel)]), which has ALREADY written the new
  //   value into contact.name before this handler runs, so it cannot be compared here.
  //   mat-select only emits ngModelChange when a different option is picked.
  if (type === 'mobile_number' && (previousNumber ?? '') !== (event ?? '')) {
    this.contactsEdited.emit();
  }
  if (type === 'name') {
    this.contactsEdited.emit();
  }
}

  removeItem(index, type) {
    const dialogData = new ModalModel(this.translateService.instant('PROFILE.CONFIRMDELETE'));
    const dialogRef = this.dialog.open(ModalComponent, {
      width: "450px",
      data: dialogData,
      panelClass: 'my-dialog-panel',
    });
    dialogRef.afterClosed().pipe(takeUntil(this._unsubscribeAll)).subscribe(dialogResult => {
      if (dialogResult) {
        if (type == 'phonenumber') {
          this.businessContact.splice(index, 1);
          this.contactsEdited.emit();
        }
        if (type == 'deleteformContact') {
          this.deleteformContact(index)
        }
        this.openBulkAction = false;
      }
    })

  }

  updateSubcategories(obj) {
    const dialogRef = this.dialog.open(AddCategoryComponent, {
      width: "800px",
      data: {...obj,label:this.labelName,module_name:this.moduleName}
    });
    dialogRef.afterClosed().pipe(takeUntil(this._unsubscribeAll)).subscribe(async (dialogResult) => {
      if(dialogResult){
        this.getAllListing()
      }
      this.openBulkAction = false;
    });
  }

  deleteformContact(id) {
    const deleteformOfContactTypesSubs = this.editContactService.deleteformOfContactTypes(id).pipe(takeUntil(this._unsubscribeAll)).subscribe((res) => {
      this.getAllListing();
    })
  }

  formatPhoneNumber(value: any, index): void {
    let inputValue: any = value;    
    if (!inputValue) return;

    const selectedCountry = this.businessContact[index]?.country_code || this.selectedCountry || 'US';
    
    try {
      // Use parsePhoneNumberFromString which is more lenient than isValidNumber
      // It will return a PhoneNumber object if the number is "possible" (correct length etc.)
      // even if the area code is technically invalid for that country.
      let phoneNumber: any = parsePhoneNumberFromString(inputValue, selectedCountry as CountryCode);
      
      if (phoneNumber && phoneNumber.isPossible()) {
        const formatted = phoneNumber.formatNational();
        if (formatted !== this.businessContact[index].mobile_number) {
            this.businessContact[index].mobile_number = formatted;
        }
      }
    } catch (e) {
      console.error('Phone formatting error:', e);
    }
    
    this.removeErrorMsg();
    this.sendSelectedContacts.emit(this.businessContact)
  }

  // changeColor(event) {
  //   this.color = event?.target?.value;
  //   this.formOfContactForm1?.controls['color'].setValue(event?.target?.value);
  // }

  // changeColor1(event) {
  //   this.color = event?.target?.value ? ('#' + event?.target?.value.replace(/#/g, "")) : null;
  //   this.formOfContactForm1?.controls['color'].setValue(this.color);
  // }

removeErrorMsg() {

  // Do not validate if Next was never clicked
  if (!this.isValidationTriggered) {
    return;
  }

  if (!this.phoneRequired) {
    this.businessContact.forEach(contact => {
      contact.phoneError = false;
      contact.phoneNameError = false;
    });
    return;
  }

  this.businessContact.forEach(contact => {
    contact.phoneError = !contact.mobile_number;

    if (this.fields?.type?.length) {
      contact.phoneNameError = !contact.name;
    } else {
      contact.phoneNameError = false;
    }
  });

}


  ngOnDestroy(): void {
    this.closePhoneNameModal();
    this._unsubscribeAll.next(undefined);
    this._unsubscribeAll.complete();
  }
}
 